import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { userinfo } from '../../Services/userinfo';
import { restURL } from '../../Models/restURL';
import Swal from 'sweetalert2';
@Component({
    selector: 'PolicyWordings',
    templateUrl: 'PolicyWordings.html',
    styleUrls: ['PolicyWordings.css']
})
export class PolicyWordings {

    public Select: boolean;
    public SelectMid: boolean;
    constructor(public url: restURL,private router: Router, private usrinfo: userinfo) {
    }

    SelectDocument(Val) {
        if (Val == "Word") {
            this.Select = true;
            this.SelectMid = false;
        }
        else   if (Val == "MID") {
            this.Select = false;
            this.SelectMid = true;
        }
    }
    CommingSoon(){
        Swal("Comming Soon...","","info")
      }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PolicyWordings/PolicyWordings.ts